import styled from 'styled-components';

import { TCustomRadionSelectorDirection } from './types';

interface IOptionWrapperProps {
  direction: TCustomRadionSelectorDirection;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OptionsWrapper = styled.div<IOptionWrapperProps>`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.md};
  flex-direction: ${({ direction }) => direction};

  > * {
    min-width: 200px;
    flex: 1;
  }
`;
